/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const MarketingPlan56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M8 36c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm36-20a8 8 0 110 16 8 8 0 010-16z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M44.937 46.5a3.998 3.998 0 01-3.968 3.5h-26A4 4 0 0111 46.5a5.98 5.98 0 003.969 1.5h26c1.521 0 2.91-.566 3.968-1.5zM14 8.127v37.748a4.002 4.002 0 01-3-3.874V12l.005-.206A4.004 4.004 0 0114 8.126zM29 27c.702 0 1.375.12 2 .342V29c0 1.054.816 1.918 1.85 1.995L33 31h1.659c.197.559.314 1.155.337 1.775L35 33h-4l-.15-.005a2.001 2.001 0 01-1.844-1.838L29 31v-4z"
            />
            <path fill={vars.white} d="M15 8h26c2.21 0 4 1.79 4 4v30c0 2.21-1.79 4-4 4H15V8z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M41 6a6 6 0 015.996 5.775L47 12v34a6 6 0 01-5.775 5.996L41 52H15a6 6 0 01-5.996-5.775L9 46V12a6 6 0 015.775-5.996L15 6h26zm.225 41.996L41 48H15a5.974 5.974 0 01-3.936-1.472l-.032-.027a3.999 3.999 0 003.765 3.494L15 50h26a4 4 0 003.969-3.5l.029-.026a5.974 5.974 0 01-3.773 1.522zM41 8H15v38h26a4 4 0 003.995-3.8L45 42V12c0-2.21-1.79-4-4-4zm-27 .126a4.003 4.003 0 00-2.995 3.668L11 12v30a4.002 4.002 0 003 3.874V8.126zM29 27v4c0 1.054.816 1.918 1.85 1.995L31 33h4a6 6 0 11-6-6zm2-3a7 7 0 017 7h-5a2 2 0 01-2-2v-5zm4.5-6a.5.5 0 010 1h-11a.5.5 0 010-1h11zm2-2a.5.5 0 010 1h-15a.5.5 0 010-1h15z"
            />
        </g>
    </AccessibleSVG>
);

export default MarketingPlan56;
